var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAssuredWorkload = function SvgAssuredWorkload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#e8eaed",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200-280v-280h80v280zm240 0v-280h80v280zM80-640v-80l400-200 400 200v80zm179-80h442L480-830zM80-120v-80h482q2 21 5 40.5t9 39.5zm600-310v-130h80v90zM800 0q-69-17-114.5-79.5T640-218v-102l160-80 160 80v102q0 76-45.5 138.5T800 0m-29-120 139-138-42-42-97 95-39-39-42 43zM259-720h442z"
  })));
};
export default SvgAssuredWorkload;